import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-post-places',
  templateUrl: './post-places.component.html',
  styleUrls: ['./post-places.component.css']
})
export class PostPlacesComponent implements OnInit {
    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2206))[0];
    }

    private loadGrid() {
        if (!!this.setting?.view_id && !!this.setting?.p2_datatask_keyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting?.view_id)
                    .setLoadDataFunction({
                        method: this.setting?.p2_datatask_keyno,
                        parameters: {}
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'postplaces_new',
                        text: 'postplaces_new',
                        func: () => this.stateService?.go('postplace', { postplace_id: '0' }),
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    view_id: string;
    p2_datatask_keyno: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('postPlaces', {
//        templateUrl: 'views/components/views/postPlaces/postPlaces.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'postPlacesService', 'ttGridFactory', function (stateService, utilityService, postPlacesService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                setting: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'postplaces_new',
//                    text: 'postplaces_new',
//                    func: () => stateService.go('postplace', { postplace_id: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await postPlacesService.getPostPlaces())[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: {}
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
